import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import App from './App';
import PrivacyPolicy from './PrivacyPolicy';
import CookiePolicy from './CookiePolicy';
import Payment from './Payment';
import Services from './Services';
import ServiceLandingPage from './ServiceLandingPage';
import Quote from './Quote';
import Terms from './Terms';
import NotFound from './NotFound';

import SiteTerms from './SiteTerms';
import Process from './Process';
import ScopeOfWork from './ScopeOfWork';
import Discovery from "./Discovery";
import Forms from "./Forms"; 

import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    
    <BrowserRouter>
      <ErrorBoundary>
        <Routes>

          
          <Route path="/index.html" element={<Navigate to="/" replace />} />

          <Route path="/" element={<App />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/services" element={<Services />} />
          <Route path="/small-business-websites-cleveland" element={<ServiceLandingPage type="smallBusiness" />} />
          <Route path="/restaurant-websites-cleveland" element={<ServiceLandingPage type="restaurant" />} />
          <Route path="/contractor-websites-cleveland" element={<ServiceLandingPage type="contractor" />} />
          <Route path="/quote" element={<Quote />} />
          
          
          <Route path="/forms" element={<Forms />} /> 
          <Route path="/discovery" element={<Discovery />} />
          <Route path="/scope-of-work" element={<ScopeOfWork />} />
          
          <Route path="/pay" element={<Payment />} />

          
          <Route path="/terms" element={<Terms />} />

          
          <Route path="/site-terms" element={<SiteTerms />} />
          <Route path="/process" element={<Process />} />

          
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();

